import { render, staticRenderFns } from "./apd_M.vue?vue&type=template&id=98a6cdfa&scoped=true"
import script from "./apd_M.vue?vue&type=script&lang=js"
export * from "./apd_M.vue?vue&type=script&lang=js"
import style0 from "./apd_M.vue?vue&type=style&index=0&id=98a6cdfa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "98a6cdfa",
  null
  
)

export default component.exports